<template>
    <div>

        <!-- <h6 class="heading-small text-muted mb-4">Add New Customer {{ (this.customer.firstName) ? (" - " + this.customer.firstName) : "" }}</h6> -->
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }} </h6>
        <h6 v-else-if="profileId != 0 && $attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }}</h6>
        <!-- <small> {{ customer }} </small> -->

         <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <!-- <br/> <br/> <br/>  -->

        <div class="row mt-3">
            <div class="col-md-3">
                <a-steps :current="current" direction="vertical" @change="onChange" progress-dot>
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
            </div>

            <div class="steps-content col-md-9" >
                <!-- FORM HERE -->
                <form id="form-proper">
                    <div v-if="customFormMode == 1 || customFormMode == 3">

                        <div v-if="current == 0" class="row">

                            <div class="clearfix col-md-2">
                                <base-input alternative="" label="Upload Photo">
                                    <a-upload
                                        accept=".jpg, .jpeg, .png"
                                        :disabled="viewMode"
                                        :action="uploadCustomerImage"
                                        listType="picture-card"
                                        :fileList="fileList"
                                        @preview="handlePreview"
                                        @change="handleChange"
                                        :headers="authHeaders"
                                        :before-upload="beforeUpload"
                                    >
                                        <div v-if="fileList.length < 1 && imageLoaded == true"> +
                                            <div class="ant-upload-text">Upload</div>
                                        </div>
                                    </a-upload>
                                    <small class="font-italic">Recommended image size: 1000px × 1000px</small>
                                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                        <img alt="example" style="width: 100%" :src="previewImage" />
                                    </a-modal>
                                </base-input>
                            </div>

                            <div class="col-md-10">
                                <base-input label="Code">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.code"/>
                                </base-input>

                                 <base-input label="First Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.first_name"/>
                                </base-input>

                                <base-input label="Last Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.last_name"/>
                                </base-input>

                                <base-input label="Gender" >
                                    <a-select :disabled="viewMode" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.gender">
                                        <a-select-option key="F" value="F">FEMALE</a-select-option>
                                        <a-select-option key="M" value="M">MALE</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="Available Discount" disabled>
                                    <a-input disabled type="number" v-model="customer.available_discount"/>
                                </base-input>

                                <base-input label="Status" >
                                    <base-checkbox :disabled="viewMode" class="col-md-12"  v-model="is_active">
                                        Active
                                    </base-checkbox>
                                </base-input>

                            </div>

                            <div class="col-md-12">
                                <a-switch :disabled="viewMode" class="float-right ml-2"" checked-children="MOV" un-checked-children="MOV" v-model="customer.is_mov"/>
                                <a-switch :disabled="viewMode" class="float-right ml-2" checked-children="PNSTM" un-checked-children="PNSTM" v-model="customer.is_pnstm"/>
                                <a-switch :disabled="viewMode" class="float-right ml-2" checked-children="SENIOR" un-checked-children="SENIOR" v-model="customer.is_senior_citizen"/>
                                <a-switch :disabled="viewMode" class="float-right" checked-children="PWD" un-checked-children="PWD" v-model="customer.is_pwd"/>
                            </div>
                        </div>

                        <div v-if="current == 1" class="row">
                            <h4 v-if="(viewMode || profileId) && !showSensitiveInfo"
                                class="alert alert-danger">
                                You don't have the permission to view/edit the following information
                            </h4>

                            <base-input class="col-md-12" label="Civil Status" >
                                <a-select :disabled="disableSensitiveFields()" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.civil_status">
                                    <a-select-option v-for="option in civilOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input class="col-md-6" label="Birthday" >
                                <br/>
                                <a-date-picker :disabled="disableSensitiveFields()" v-model="customer.birthday" :format="dateFormat" style="width: 100%;"/>
                            </base-input>

                            <base-input class="col-md-6" label="City of Birth">
                                <a-input :disabled="disableSensitiveFields()" type="text" v-model="customer.city_of_birth"/>
                            </base-input>

                            <base-input class="col-md-12" label="Nationality">
                                <a-input :disabled="disableSensitiveFields()" type="text" v-model="customer.nationality"/>
                            </base-input>

                            <base-input class="col-md-12" label="Religion">
                                <a-input :disabled="disableSensitiveFields()" type="text" v-model="customer.religion"/>
                            </base-input>
                            
                            <base-input class="col-md-12" label="TIN">
                                <a-input :disabled="disableSensitiveFields()" type="text" v-model="customer.tin"/>
                            </base-input>

                        </div>

                        <div v-if="current == 2" class="row">
                            <base-input class="col-md-12" label="Region">
                                <a-select v-model="customer.address.region_code" showSearch placeholder="Select Region" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true || viewMode">
                                    <a-select-option v-for="option in addressOptions.regions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input class="col-md-12" label="Province">
                                <a-select v-model="customer.address.province_code" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true || viewMode">
                                    <a-select-option v-for="option in addressOptions.provinces" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input class="col-md-12" label="City">
                                <a-select v-model="customer.address.city_code" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true || viewMode">
                                    <a-select-option v-for="option in addressOptions.cities" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input class="col-md-12" label="Barangay">
                                <a-select v-model="customer.address.barangay_code" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true || viewMode">
                                    <a-select-option v-for="option in addressOptions.barangays" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input label="Street" class="col-md-12">
                                <a-input :disabled="viewMode" type="text" v-model="customer.address.street"/>
                            </base-input>
                        </div>

                        <div v-if="current == 3" class="row">

                            <base-input label="Mobile" class="col-md-12">
                                <small class="ml-1"> (e.g. +639123456789)</small>
                                <a-input :disabled="viewMode" type="text" v-model="customer.mobile" addonBefore="+" />
                            </base-input>

                            <base-input label="Telephone" class="col-md-12">
                                <a-input :disabled="viewMode" type="text" v-model="customer.telephone"/>
                            </base-input>

                            <base-input label="Fax" class="col-md-12">
                                <a-input :disabled="viewMode" type="text" v-model="customer.fax"/>
                            </base-input>

                            <base-input label="Email" class="col-md-12">
                                <a-input :disabled="viewMode" type="text" v-model="customer.email" />
                            </base-input>

                        </div>

                        <div v-if="current == 4" class="row">
                            <base-input label="Discount" class="col-md-12">
                                <a-input :disabled="viewMode" type="text" v-model="customer.discount_text" addonAfter="%"/>
                            </base-input>

                            <base-input label="Vat Type" class="col-md-12">
                                <a-select :disabled="viewMode" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.vat_type">
                                    <a-select-option v-for="option in vatTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input label="Customer Type" class="col-md-12" required>
                                <a-select   showSearch
                                            v-model="customer.customer_type_id"
                                            style="width: 100%" placeholder="Please select"
                                            :filterOption="false"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="viewMode"
                                            @search="handleCusTypeSearch"
                                            @focus="handleCusTypeSearch"
                                            required
                                >
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="option in customerTypes" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input label="Card Type" class="col-md-12">
                                <a-select   showSearch
                                            v-model="customer.customer_card_type_id"
                                            style="width: 100%" placeholder="Please select"
                                            :filterOption="false"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="viewMode"
                                            @search="handleCardTypeSearch"
                                            @focus="handleCardTypeSearch"
                                >
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="option in cardTypes" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input label="Payment Terms" class="col-md-12">
                                <a-select   showSearch
                                            v-model="customer.payment_term_id"
                                            style="width: 100%" placeholder="Please select"
                                            :filterOption="false"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="viewMode"
                                            @search="handlePaymentTermSearch"
                                            @focus="handlePaymentTermSearch"
                                >
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="option in paymentTerms" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>


                        </div>

                        <div v-if="current == 5" class="row">
                            <h4 v-if="(viewMode || profileId) && !showSensitiveInfo"
                                class="alert alert-danger">
                                You don't have the permission to view/edit the following information
                            </h4>

                            <base-input label="ID Type" class="col-md-12">
                                <a-select
                                    style="width: 100%"
                                    placeholder="Please select"
                                    optionFilterProp="children"
                                    :disabled="disableSensitiveFields()"
                                    v-model="customer.identification.type">
                                    <a-select-option v-for="option in idOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input v-if="['8'].includes(customer.identification.type)" label="Company" class="col-md-12">
                                <a-select
                                    style="width: 100%"
                                    placeholder="Please select"
                                    optionFilterProp="children"
                                    :disabled="disableSensitiveFields()"
                                    v-model="customer.identification.company_id">
                                    <a-select-option v-for="option in companyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>

                            <base-input label="ID Number" class="col-md-12">
                                <a-input :disabled="disableSensitiveFields()" type="text" v-model="customer.identification.number"/>
                            </base-input>

                            <base-input v-if="!['2','3'].includes(customer.identification.type)" label="ID Expiration" class="col-md-12">
                                <!-- <a-input type="text" v-model="customer.id.expiration" /> -->
                                <a-date-picker :disabled="disableSensitiveFields()" v-model="customer.identification.expiration" :format="dateFormat" style="width: 100%;"/>
                            </base-input>


                        </div>

                        <div v-if="current == 6" class="row">
                            <base-input label="Consent Given At" class="col-md-12">
                                <!-- <a-input type="text" v-model="customer.id.expiration" /> -->
                                <a-date-picker :disabled="viewMode" v-model="customer.consent.date" :format="dateFormat" style="width: 100%;"/>
                            </base-input>

                            <div class="col-md-12 mb-2">
                                <h6 class="heading-small text-muted mt-0">Search Settings</h6>
                                <small>Customer gave consent to be searched: </small>
                            </div>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.name" checked>
                                By Name
                            </base-checkbox>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.phone">
                                By Phone
                            </base-checkbox>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.email">
                                By Email
                            </base-checkbox>

                            <div class="col-md-12 mb-2 mt-3">
                                <h6 class="heading-small text-muted">Others</h6>
                                <small>Customer gave consent to: </small>
                            </div>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.consent.third_party">
                                Share his/her information to third-party applications
                            </base-checkbox>

                        </div>

                        <div v-if="current == 7" class="row">
                            <dynamic-form :convertedJson="{mode: 'list', groups: customForm.groups_append}" :formSettings="this.customer" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </div>

                    </div>

                    <div v-if="customFormMode == 2">
                        <div v-if="current == 0" class="row">
                            <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="this.customer" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
                        </div>
                        <div v-if="current == 1" class="row">
                            <base-input label="Consent Given At" class="col-md-12">
                                <!-- <a-input type="text" v-model="customer.id.expiration" /> -->
                                <a-date-picker :disabled="viewMode" v-model="customer.consent.date" :format="dateFormat" style="width: 100%;"/>
                            </base-input>

                            <div class="col-md-12 mb-2">
                                <h6 class="heading-small text-muted mt-0">Search Settings</h6>
                                <small>Customer gave consent to be searched: </small>
                            </div>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.name" checked>
                                By Name
                            </base-checkbox>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.phone">
                                By Phone
                            </base-checkbox>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.search_settings.email">
                                By Email
                            </base-checkbox>

                            <div class="col-md-12 mb-2 mt-3">
                                <h6 class="heading-small text-muted">Others</h6>
                                <small>Customer gave consent to: </small>
                            </div>

                            <base-checkbox :disabled="viewMode" class="col-md-12 ml-5"  v-model="customer.consent.third_party">
                                Share his/her information to third-party applications
                            </base-checkbox>
                        </div>
                    </div>

                </form>
            </div>
        </div>

        <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <div class="steps-action float-right">
                <button v-if="current>0" style="margin-left: 8px" @click="current--" class="btn btn-sm btn-primary">
                  Previous
                </button>
                <button v-if="current < steps.length - 1" type="primary" @click="current++" class="btn btn-sm btn-primary">
                  Next
                </button>
                <button
                  class="btn btn-sm btn-success"
                  v-if="current == steps.length - 1 && viewMode == false"
                  type="primary"
                  @click="done"
                >
                  Done
                </button>
            </div>
        </div>

    </div>

</template>

<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'

import { mapState } from 'vuex'
import axios from "axios";
import moment from 'moment';

var component_x;

export default {
    components: {
            DynamicForm
    },
    data() {
        return {
            dynamicFormKey: 0,
            viewMode: false,
            customFormMode: 1,
            customForm: {},
            customer: {
                identification: {
                    type: "2"
                },
                consent: {
                    date: moment(),
                    third_party: false
                },
                address: {
                    region_code: null,
                    region_name: "",
                    province_code: null,
                    province_name: "",
                    city_code: null,
                    city_name: "",
                    barangay_code: null,
                    barangay_name: ""
                },
                search_settings: {
                    name: true,
                    phone: false,
                    email: false
                },
                status: 'A'
            },
            is_active: true,
            // Form
            civilOptions: [
                    // {key: null, value: null},
                    {key: "S", value: "SINGLE"},
                    {key: "M", value: "MARRIED"},
                    {key: "W", value: "WIDOWER"}
            ],
            idOptions: [
                    // {key: null, value: null},
                    {key: "1", value: "Passport"},
                    {key: "2", value: "TIN"},
                    {key: "3", value: "UMID"},
                    {key: "4", value: "SSS"},
                    {key: "5", value: "License"},
                    {key: "6", value: "Postal ID"},
                    {key: "8", value: "Employee ID"},
                    {key: "7", value: "Others"},
            ],
            companyOptions: [],
            vatTypeOptions: [
                    // {key: null, value: null},
                    {key: "V", value: "VATable"},
                    {key: "X", value: "VAT-exempt"},
                    {key: "Z", value: "Zero-rated"}
            ],
            dateFormat: 'MM-DD-YYYY',
            current: 0,
            steps: [
                { title: 'Basic Info' },
                { title: 'Supporting Info' },
                { title: 'Address' },
                { title: 'Contact Details'},
                { title: 'Classification'},
                { title: 'Identification'},
                { title: 'Consent' },
            ],

            // UPLOADER
            previewVisible: false,
            previewImage: '',
            fileList: [],
            imageLoaded: true,
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File" },
            errors: [],
            dynamicFormErrors: [],

            // ADDRESS
            addressOptions: {
                regions: [],
                provinces: [],
                cities: [],
                barangays: []
            },
            response: [],
            addressLoading: false,

            // searchable select
            fetching: false,
            customerTypes: [],
            cardTypes: [],
            paymentTerms: [],

            securedSync: false,
            showSensitiveInfo: false
        }
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
    },
    mounted: async function(){
        this.viewMode = this.serverType == 'branch' || this.$attrs.viewMode == true;

        component_x = this

        this.securedSync = false

        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Customer?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        if(this.isJsonString(accSystemModuleRequest.meta) == true){

            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }

                if(this.customFormMode == 3){
                    this.steps.push({title: "Custom Fields"})
                }

                if(this.customFormMode == 2){
                    this.steps = [ {title: "Main Form"}, {title: "Consent"}]
                }

                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        let companies = await HTTPRequest.getRequest(component_x.endPoint + 'companies', null)
        this.companyOptions = companies.data

        await this.changeAddress('regions', 1);

        if (this.profileId > 0) {
                var customer_data = await HTTPRequest.getRequest(component_x.endPoint + 'customers/' + this.profileId, null)
                this.customerData = customer_data
                if (customer_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (customer_data["error"] == undefined) {
                        this.customer = customer_data
                        this.customer.address = {
                            region_code: customer_data["region_code"],
                            region_name: customer_data["region_name"],
                            province_code: customer_data["province_code"],
                            province_name: customer_data["province_name"],
                            city_code: customer_data["city_code"],
                            city_name: customer_data["city_name"],
                            barangay_code: customer_data["barangay_code"],
                            barangay_name: customer_data["barangay_name"],
                            street: customer_data["street"]
                        }

                        this.showSensitiveInfo = customer_data.show_sensitive_info

                        if(this.customer.status == 'A'){
                            this.is_active = true
                        } else {
                            this.is_active = false
                        }

                        delete this.customer.extras
                        delete this.customer.region_code
                        delete this.customer.region_name
                        delete this.customer.province_code
                        delete this.customer.province_name
                        delete this.customer.city_code
                        delete this.customer.city_name
                        delete this.customer.barangay_code
                        delete this.customer.barangay_name
                        delete this.customer.street

                        // this.customer.consent = {}
                        if(this.customer.identification == null)
                            this.customer.identification = {}

                        if(this.customer.consent == null)
                            this.customer.consent = {}

                        if(this.customer.search_settings == null)
                            this.customer.search_settings = {}

                        var cardTypes = await HTTPRequest.getRequest(this.endPoint + "customer_card_types?id=" + this.customer.customer_card_type_id , null, null)
                        this.cardTypes =  cardTypes.data
                        // fetch current customer card type to avoid display of id
                        var currentCardType = await HTTPRequest.getRequest(this.endPoint + "customer_card_types/" + this.customer.customer_card_type_id , null, null)
                        this.cardTypes.push(currentCardType)
                        
                        var customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types?id=" + this.customer.customer_type_id , null, null)
                        this.customerTypes = customerTypes.data
                        var paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms?id=" + this.customer.payment_term_id , null, null)
                        this.paymentTerms = paymentTerms.data


                        await this.changeAddress('provinces', 1);
                        await this.changeAddress('cities', 1);
                        await this.changeAddress('barangays', 1);

                        if (customer_data["filename"] != null) {
                            this.fileList = [{
                                uid: customer_data['id'],
                                name: customer_data["filename"],
                                status: 'done',
                                url: this.publicUrl + 'customer_images/' + customer_data["filename"]
                            }]
                        } else {
                            this.fileList = []
                        }

                        this.imageLoaded = true
                    } else {
                        this.errors = customer_data["error"].split(",");
                    }
                }
            }

        // if(this.serverType == 'branch' || this.$attrs.viewMode == true){
        //     this.viewMode = true
        // }

        this.dynamicFormKey++;

    },
    watch: {
        current: async function(){
            // Old approach on viewing identification tab
            // if(this.customer.id > 0 && [1,5].includes(this.current) && this.securedSync == false){
            //     console.log("Retrieving secure data...")
            //     var customer_data = await HTTPRequest.getRequest(component_x.endPoint + 'customers/' + this.profileId + "/secure", null)

            //     if(customer_data.identification == null)
            //         customer_data.identification = {type: "1"}

            //     this.customer = Object.assign({}, this.customer, customer_data)
            //     this.securedSync = true
            // }

            // New approach on viewting identification tab
            if (!this.showSensitiveInfo) {
                this.customer_data.identification = {type: "1"}
            }
        },
        is_active: function() {
            if(this.is_active == false){
                this.customer.status = 'I'
            } else {
                this.customer.status = 'A'
            }
        },
        'customer.identification': {
            handler(value) {
                if (value.type != "8") { // not employee id
                    delete this.customer.identification.company_id
                    delete this.customer.identification.company_name
                } else if (value.type == "8" && 'company_id' in value) { // employee id
                    this.customer.identification.company_name = this.companyOptions.find(option => option.id == value.company_id).name
                }
            },
            deep: true
        }
    },
    methods: {
        disableSensitiveFields() {
            return (this.viewMode || (parseInt(this.profileId) > 0 && !this.showSensitiveInfo))
        },
        done(){
            if(this.profileId > 0){
                console.log("I am here")
                this.update()
            } else {
                console.log("Create")
                this.create()
            }
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        onChange(current) {
            this.current = current;
        },
        validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.customer.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.customer.code, 0, 30));
                this.errors.push(ValidateField.required('First Name', this.customer.first_name));
                this.errors.push(ValidateField.alphanumericWithSpace('First Name', this.customer.first_name));
                this.errors.push(ValidateField.charMinAndMax('First Name', this.customer.first_name, 0, 70));
                this.errors.push(ValidateField.required('Last Name', this.customer.last_name));
                this.errors.push(ValidateField.alphanumericWithSpace('Last Name', this.customer.last_name));
                this.errors.push(ValidateField.charMinAndMax('Last Name', this.customer.last_name, 0, 30));
                // this.errors.push(ValidateField.required('Street', this.address.street));
                // this.errors.push(ValidateField.charMinAndMax('Street', this.address.street, 0, 255));
                // this.errors.push(ValidateField.required('Phone', this.inputTelephone));
                this.errors.push(ValidateField.phoneNumberFormat('Phone', this.customer.telephone));
                this.errors.push(ValidateField.charMinAndMax('Phone', this.customer.telephone, 0, 30));
                this.errors.push(ValidateField.phoneNumberFormat('Fax', this.customer.fax));
                this.errors.push(ValidateField.charMinAndMax('Fax', this.customer.fax, 0, 30));
                // this.errors.push(ValidateField.alphanumeric('Tin', this.inputTin));
                // this.errors.push(ValidateField.charMinAndMax('Tin', this.inputTin, 0, 15));
                // this.errors.push(ValidateField.alphanumericWithSpace('Contact Person', this.inputContactPerson));
                // this.errors.push(ValidateField.charMinAndMax('Contact Person', this.inputContactPerson, 0, 50));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Position', this.inputContactPosition));
                // this.errors.push(ValidateField.charMinAndMax('Position', this.inputContactPosition, 0, 50));
                if(this.customer.email != null && this.customer.email != ""){
                    this.errors.push(ValidateField.emailFormat('Email', this.customer.email));
                }
                // this.errors.push(ValidateField.emailFormat('Email', this.customer.email));
                this.errors.push(ValidateField.charMinAndMax('Email', this.customer.email, 0, 30));
                this.errors.push(ValidateField.percentFormat('Discount', this.customer.discount_text));
                this.errors.push(ValidateField.charMinAndMax('Discount', this.customer.discount_text, 0, 50));
                this.errors.push(ValidateField.required('Customer Type', this.customer.customer_type_id));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },

        async handlePaymentTermSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms" , null, null)
            else
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms?name=" + value , null, null)

            this.paymentTerms = this.paymentTerms.data
            this.fetching = false;
        },
        async handleCusTypeSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types" , null, null)
            else
                this.customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types?name=" + value , null, null)

            this.customerTypes = this.customerTypes.data
            this.fetching = false;

        },
        async handleCardTypeSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.cardTypes = await HTTPRequest.getRequest(this.endPoint + "customer_card_types" , null, null)
            else
                this.cardTypes = await HTTPRequest.getRequest(this.endPoint + "customer_card_types?name=" + value , null, null)

            this.cardTypes = this.cardTypes.data
            this.fetching = false;
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        handleCancel () {
            this.previewVisible = false
        },
        handlePreview (file) {
            this.previewImage = file.url || file.thumbUrl
            this.previewVisible = true
        },
        handleChange ({ fileList }) {
            this.fileList = fileList;
        },
        uploadCustomerImage() {
            return this.endPoint + 'customers/upload_image'
        },
        removeSensitiveData() {
            // Delete data in customer object all the sensitive data
            // if the user is not allowed to view/edit sensitive data

            if (this.showSensitiveInfo) return;
            delete this.customer.identification;
        },
        update: async function () {
            // console.log(this.customFormMode)
            // if(this.customFormMode == 1 || this.customFormMode == 3){
                console.log("************");
                // console.log(this.errors);
                if(!this.validateForm() && this.dynamicFormErrors.length == 0) {
                    this.removeSensitiveData();

                    let file = null;
                    if(this.fileList.length > 0){
                        if (this.fileList[0].response == undefined){
                            file = this.fileList[0].name
                        } else {
                            file = this.fileList[0].response
                        }
                    }

                    var address = this.customer.address
                    delete this.customer['address']
                    this.customer.filename = file

                    Object.assign(this.customer, address)
                    var customerPayload = { customer: this.customer }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'customers/' + this.profileId, null, customerPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }

                } else {
                    this.errors = this.dynamicFormErrors
                }
            // }
        },
        create: async function () {
            // switch(this.customFormMode){
            //         case 1:
                        if(!this.validateForm()) {
                            let file = null;
                            if(this.fileList.length > 0){
                                if (this.fileList[0].response == undefined){
                                    file = this.fileList[0].name
                                } else {
                                    file = this.fileList[0].response
                                }
                            }

                            var address = this.customer.address
                            delete this.customer['address']
                            this.customer.filename = file
                            Object.assign(this.customer, address)
                            var customerPayload = { customer: this.customer }

                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'customers', null, customerPayload)
                            if (post_request == undefined) {
                                this.$emit('refreshPage', event)
                            } else {
                                if (post_request["error"] == undefined) {
                                    this.$emit('refreshPage', event)
                                } else {
                                    this.errors = post_request["error"].split(",")
                                }
                            }

                        }
            //         break;
            // }
        },
        updateSettings(newFormSettings, settingsGrouping, errors){
          var formSettingsCopy = this.customer
          var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
          this.formErrors = errors

          if(this.customFormMode == 3) {
              this.dynamicFormErrors = errors
              this.errors = errors
          }
          this.customer = mergedHash

        },
        changeAddress: async function(list, fresh = 0){
            this.addressLoading = true
            switch(list) {
            case 'regions':
                await this.getList(null, null, list)

                this.sort(this.response)
                this.addressOptions = {
                    regions: this.response,
                    provinces: [],
                    cities: [],
                    barangays: []
                }

                if(fresh == 0){
                    Object.assign(this.customer.address, {
                        province_code: null,
                        province_name: "",
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });
                }

                break;
            case 'provinces':
                let province_list = []
                let district_list = []

                if(this.customer.address.region_code != null){
                    await this.getList(list, this.customer.address.region_code, 'regions')
                    province_list = this.response

                    await this.getList('districts', this.customer.address.region_code, 'regions')
                    district_list = this.response

                    Object.assign(this.customer.address, {
                        region_name: this.addressOptions.regions.find(x => x.code === this.customer.address.region_code).name
                    })
                }

                let provinces_arr = province_list.concat(district_list)
                this.sort(provinces_arr)

                Object.assign(this.addressOptions, {
                    provinces: provinces_arr,
                    cities: [],
                    barangays: []
                });

                if(fresh == 0){
                    Object.assign(this.customer.address, {
                        province_code: null,
                        province_name: "",
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });
                }

                break;
            case 'cities':
                let province_city_list = []
                let province_municipality_list = []
                let province_sub_municipality_list = []
                let district_city_list = []
                let district_municipality_list = []
                let district_sub_municipality_list = []

                if(this.customer.address.province_code != null){
                    await this.getList(list, this.customer.address.province_code, 'provinces')
                    province_city_list = this.response

                    await this.getList('municipalities', this.customer.address.province_code, 'provinces')
                    province_municipality_list = this.response

                    await this.getList('sub-municipalities', this.customer.address.province_code, 'provinces')
                    province_sub_municipality_list = this.response

                    await this.getList(list, this.customer.address.province_code, 'districts')
                    district_city_list = this.response

                    await this.getList('municipalities', this.customer.address.province_code, 'districts')
                    district_municipality_list = this.response

                    await this.getList('sub-municipalities', this.customer.address.province_code, 'districts')
                    district_sub_municipality_list = this.response

                    Object.assign(this.customer.address, {
                        province_name: this.addressOptions.provinces.find(x => x.code === this.customer.address.province_code).name
                    })
                }

                let cities_arr = province_city_list.concat(province_municipality_list, province_sub_municipality_list, district_city_list, district_municipality_list, district_sub_municipality_list)
                this.sort(cities_arr)

                Object.assign(this.addressOptions, {
                    cities: cities_arr,
                    barangays: []
                });

                if(fresh == 0){
                    Object.assign(this.customer.address, {
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });
                }

                break;
            case 'barangays':
                let city_barangay_list = []
                let municipality_barangay_list = []
                let sub_municipality_barangay_list = []

                if(this.customer.address.city_code != null){
                    await this.getList(list, this.customer.address.city_code, 'cities')
                    city_barangay_list = this.response
                    await this.getList(list, this.customer.address.city_code, 'municipalities')
                    municipality_barangay_list = this.response
                    await this.getList(list, this.customer.address.city_code, 'sub-municipalities')
                    sub_municipality_barangay_list = this.response

                    Object.assign(this.customer.address, {
                        city_name: this.addressOptions.cities.find(x => x.code === this.customer.address.city_code).name
                    })

                    this.addressOptions.barangays = this.response
                }

                let barangay_arr = city_barangay_list.concat(municipality_barangay_list, sub_municipality_barangay_list)
                this.sort(barangay_arr)

                Object.assign(this.addressOptions, {
                    barangays: barangay_arr
                });

                if(fresh == 0){
                    Object.assign(this.customer.address, {
                        barangay_code: null,
                        barangay_name: ""
                    });
                }

                break;
            default:
                if(this.customer.address.barangay_code != null){
                    Object.assign(this.customer.address, {
                        barangay_name: this.addressOptions.barangays.find(x => x.code === this.customer.address.barangay_code).name
                    })
                }
            }

            this.addressLoading = false
        },
        getList: async function(list, parent_code, parentList){
            component_x = this;

            let code
            if (parent_code == null){
                code = ''
            } else {
                code = parent_code + '/' + list
            }

            await axios({
                method: 'GET',
                url: 'https://psgc.gitlab.io/api/' + parentList + '/' + code
            })
            .then(function (response) {
                let response_data = response.data
                let response_array = []
                for (let index = 0; index < response_data.length; index++) {
                    let row_set = response_data[index]
                    response_array.push({
                        code: row_set.code.toString(),
                        name: row_set.name
                    })
                }
                component_x.response = response_array
            }).catch(err => {
                component_x.response = []
            })
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.$message.error('Image must be a JPG or PNG file');
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('Image must be smaller than 2MB');
            }
            return isJpgOrPng && isLt2M;
        },

    }

}
</script>>
